export const contactsData = {
    email: 'Noibisjunior22@gmail.com',
    phone: '+23409057210160',
    address: 'Abuja,Nigeria ',
    github: 'https://github.com/Noibisjunior',
    linkedIn: 'https://www.linkedin.com/in/ abdulsalaam-noibi',
    twitter: 'https://X.com/clericcoder',
    devUsername: "noibisdev",
}